import { useSearchParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { ServiceCode } from '@common/enums';
import type { IReduxState } from '../../../configureStore';
import type { IServiceProvider } from '../../interfaces/serviceProvider';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';
import { Loader } from '../../elements/common';
import { SelectEmployment } from './SelectEmployment';

export function EmploymentsSelectOneServiceProvider() {
    const abortableFetch = useAbortableFetch();
    const [serviceProviders, setServiceProviders] = useState<IServiceProvider[]>([]);
    const practitionerId = useSelector((state: IReduxState) => state.authentication.id);
    const [searchParams] = useSearchParams();
    const serviceCode = searchParams.get('serviceCode') as ServiceCode;
    const redirectTo = searchParams.get('redirectTo') as string;

    useEffect(() => {
        loadServiceProviders();
    }, []);

    const employments = serviceProviders.map((serviceProvider) => serviceProvider.employment);

    return serviceProviders === undefined ? (
        <Loader
            centered
            large
        />
    ) : (
        <SelectEmployment
            employments={employments}
            selectEmployment={selectEmployment}
        />
    );

    async function loadServiceProviders() {
        const url = `/api/serviceProviders?serviceCode=${serviceCode}&practitionerId=${practitionerId}&isActive=true`;
        const result = await abortableFetch.fetchJson(url, 'GET');
        setServiceProviders(result.json.items);
    }

    async function selectEmployment(employmentId: string) {
        window.location.href = redirectTo + `&employmentId=${employmentId}`;
    }
}
